type StatesAndCities = { [stateCode: string]: string[] };

export const statesAndCities: StatesAndCities = {
  AL: [
    'Birmingham',
    'Montgomery',
    'Mobile',
    'Huntsville',
    'Tuscaloosa',
    'Hoover',
    'Dothan',
    'Auburn',
    'Decatur',
    'Madison',
  ],
  AK: ['Anchorage'],
  AZ: ['Phoenix', 'Tucson'],
  AR: ['Little Rock', 'Fort Smith', 'Fayetteville', 'Conway'],
  CA: [
    'San Diego',
    'San Jose',
    'San Francisco',
    'Fresno',
    'Sacramento',
    'Long Beach',
    'Oakland',
    'Bakersfield',
    'Anaheim',
  ],
  CO: ['Denver', 'Colorado Springs', 'Aurora', 'Fort Collins', 'Lakewood', 'Thornton', 'Arvada'],
  CT: [
    'Bridgeport',
    'New Haven',
    'Stamford',
    'Hartford',
    'Waterbury',
    'Norwalk',
    'Danbury',
    'New Britain',
    'Bristol',
    'Meriden',
  ],
  DE: ['Wilmington', 'Dover', 'Newark', 'Middletown', 'Smyrna', 'Milford', 'Seaford', 'Georgetown'],
  FL: [
    'Tampa',
    'Orlando',
    'St. Petersburg',
    'Hialeah',
    'Tallahassee',
    'Fort Lauderdale',
    'Cape Coral',
  ],
  GA: [
    'Atlanta',
    'Augusta',
    'Columbus',
    'Savannah',
    'Athens',
    'Sandy Springs',
    'Roswell',
    'Macon',
    'Johns Creek',
  ],
  HI: ['Honolulu'],
  ID: [
    'Boise',
    'Meridian',
    'Nampa',
    'Idaho Falls',
    'Pocatello',
    'Caldwell',
    "Coeur d'Alene",
    'Twin Falls',
    'Lewiston',
    'Rexburg',
  ],
  IL: [
    'Aurora',
    'Rockford',
    'Joliet',
    'Naperville',
    'Springfield',
    'Peoria',
    'Elgin',
    'Waukegan',
    'Cicero',
  ],
  IN: [
    'Indianapolis',
    'Fort Wayne',
    'Evansville',
    'South Bend',
    'Carmel',
    'Fishers',
    'Bloomington',
    'Hammond',
    'Gary',
    'Muncie',
  ],
  IA: [
    'Des Moines',
    'Cedar Rapids',
    'Davenport',
    'Sioux City',
    'Iowa City',
    'Waterloo',
    'Ankeny',
    'Dubuque',
  ],
  KS: [
    'Wichita',
    'Overland Park',
    'Kansas City',
    'Olathe',
    'Topeka',
    'Lawrence',
    'Shawnee',
    'Manhattan',
    'Lenexa',
    'Salina',
  ],
  KY: [
    'Louisville',
    'Lexington',
    'Bowling Green',
    'Owensboro',
    'Covington',
    'Richmond',
    'Georgetown',
    'Florence',
    'Elizabethtown',
    'Hopkinsville',
  ],
  LA: ['New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette', 'Monroe', 'Houma'],
  ME: ['Portland', 'Lewiston', 'Bangor', 'South Portland'],
  MD: [
    'Baltimore',
    'Columbia',
    'Germantown',
    'Silver Spring',
    'Waldorf',
    'Glen Burnie',
    'Ellicott City',
    'Frederick',
    'Dundalk',
  ],
  MA: [
    'Boston',
    'Worcester',
    'Springfield',
    'Lowell',
    'Cambridge',
    'New Bedford',
    'Brockton',
    'Quincy',
    'Lynn',
    'Fall River',
  ],
  MI: [
    'Detroit',
    'Grand Rapids',
    'Warren',
    'Sterling Heights',
    'Ann Arbor',
    'Lansing',
    'Flint',
    'Livonia',
    'Troy',
  ],
  MN: ['Minneapolis', 'Saint Paul', 'Rochester', 'Duluth', 'Brooklyn Park', 'St. Cloud'],
  MS: [
    'Jackson',
    'Gulfport',
    'Southaven',
    'Hattiesburg',
    'Biloxi',
    'Meridian',
    'Tupelo',
    'Olive Branch',
    'Clinton',
    'Vicksburg',
  ],
  MO: ['Kansas City', 'St. Louis', 'Springfield', 'Columbia', "Lee's Summit"],
  MT: ['Billings', 'Missoula', 'Great Falls', 'Bozeman'],
  NE: [
    'Omaha',
    'Lincoln',
    'Bellevue',
    'Grand Island',
    'Kearney',
    'Fremont',
    'Hastings',
    'North Platte',
    'Norfolk',
    'Columbus',
  ],
  NV: ['Las Vegas', 'Henderson', 'Reno', 'North Las Vegas', 'Carson City', 'Mesquite', 'Fernley'],
  NH: ['Manchester', 'Nashua', 'Concord', 'Derry', 'Dover', 'Rochester', 'Salem', 'Merrimack'],
  NJ: [
    'Newark',
    'Jersey City',
    'Paterson',
    'Elizabeth',
    'Toms River',
    'Trenton',
    'Camden',
    'Passaic',
    'Union City',
  ],
  NM: [
    'Albuquerque',
    'Las Cruces',
    'Rio Rancho',
    'Santa Fe',
    'Roswell',
    'Farmington',
    'Clovis',
    'Hobbs',
    'Alamogordo',
    'Carlsbad',
  ],
  NY: [
    'Buffalo',
    'Rochester',
    'Yonkers',
    'Syracuse',
    'Albany',
    'New Rochelle',
    'Mount Vernon',
    'Schenectady',
    'Utica',
  ],
  NC: [
    'Charlotte',
    'Raleigh',
    'Greensboro',
    'Durham',
    'Winston-Salem',
    'Fayetteville',
    'Cary',
    'Wilmington',
    'High Point',
    'Asheville',
  ],
  ND: [
    'Fargo',
    'Bismarck',
    'Grand Forks',
    'Minot',
    'West Fargo',
    'Williston',
    'Dickinson',
    'Jamestown',
  ],
  OH: ['Cleveland', 'Cincinnati', 'Toledo', 'Akron', 'Dayton', 'Parma', 'Canton', 'Youngstown'],
  OK: [
    'Oklahoma City',
    'Tulsa',
    'Norman',
    'Lawton',
    'Edmond',
    'Moore',
    'Midwest City',
    'Enid',
    'Stillwater',
  ],
  OR: [
    'Portland',
    'Eugene',
    'Salem',
    'Gresham',
    'Beaverton',
    'Bend',
    'Medford',
    'Springfield',
    'Corvallis',
  ],
  PA: ['Philadelphia', 'Allentown', 'Erie', 'Reading', 'Scranton', 'Bethlehem'],
  RI: ['Providence', 'Warwick', 'Cranston', 'Pawtucket', 'Woonsocket'],
  SC: [
    'Columbia',
    'Charleston',
    'North Charleston',
    'Mount Pleasant',
    'Rock Hill',
    'Greenville',
    'Summerville',
    'Goose Creek',
    'Hilton Head Island',
    'Spartanburg',
  ],
  SD: [
    'Sioux Falls',
    'Rapid City',
    'Aberdeen',
    'Brookings',
    'Watertown',
    'Mitchell',
    'Yankton',
    'Pierre',
    'Huron',
    'Vermillion',
  ],
  TN: [
    'Nashville',
    'Memphis',
    'Knoxville',
    'Chattanooga',
    'Clarksville',
    'Murfreesboro',
    'Franklin',
    'Jackson',
    'Johnson City',
  ],
  TX: [
    'Houston',
    'San Antonio',
    'Dallas',
    'Austin',
    'Fort Worth',
    'El Paso',
    'Arlington',
    'Corpus Christi',
    'Plano',
    'Laredo',
  ],
  UT: ['Salt Lake City', 'Provo', 'Ogden'],
  VT: [
    'Burlington',
    'South Burlington',
    'Rutland',
    'Essex',
    'Barre',
    'Montpelier',
    'Winooski',
    'St. Albans',
    'Newport',
    'Northfield',
  ],
  VA: [
    'Virginia Beach',
    'Norfolk',
    'Chesapeake',
    'Richmond',
    'Newport News',
    'Alexandria',
    'Hampton',
    'Roanoke',
    'Suffolk',
  ],
  WA: [
    'Seattle',
    'Spokane',
    'Tacoma',
    'Vancouver',
    'Bellevue',
    'Kent',
    'Everett',
    'Renton',
    'Yakima',
  ],
  WV: [
    'Charleston',
    'Huntington',
    'Morgantown',
    'Parkersburg',
    'Wheeling',
    'Fairmont',
    'Weirton',
    'Martinsburg',
    'Beckley',
    'Clarksburg',
  ],
  WI: [
    'Milwaukee',
    'Madison',
    'Green Bay',
    'Kenosha',
    'Racine',
    'Appleton',
    'Waukesha',
    'Oshkosh',
    'Eau Claire',
  ],
  WY: [
    'Cheyenne',
    'Casper',
    'Laramie',
    'Gillette',
    'Sheridan',
    'Green River',
    'Evanston',
    'Riverton',
    'Jackson',
  ],
};
